<template>
    <div>
        <b-overlay :show="updatedDataUser" rounded="sm">
            <b-card>
                <b-row>
                    <b-col sm="12" md="8">
                        <b-card-title>Registro del Usuario</b-card-title>
                        <hr>
                        <b-row class="mb-2">
                            <b-col class="text-left "><b>Nombre:</b></b-col>
                            <b-col class="text-left">
                                <span v-if="!isEditing">{{ row.item.Name }}</span>
                                <b-form-input sm="9" v-if="isEditing" v-model="editedUser.Name"></b-form-input>
                            </b-col>

                        </b-row>

                        <b-row class="mb-2">
                            <b-col class="text-left overflow"><b>Apellido:</b></b-col>
                            <b-col class="text-left">
                                <span v-if="!isEditing">{{ row.item.Surname }}</span>
                                <b-form-input sm="9" v-if="isEditing" v-model="editedUser.Surname"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mb-2">
                            <b-col class="text-left overflow"><b>Email:</b></b-col>
                            <b-col class="text-left ">
                                <span v-if="!isEditing" class="overflow-auto">{{ row.item.Email }}</span>
                                <b-form-input sm="9" v-if="isEditing" v-model="editedUser.Email"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col class="text-left overflow"><b>Numero de Identificacion:</b></b-col>
                            <b-col class="text-left">
                                <span v-if="!isEditing">{{ row.item.Dni }}</span>
                                <b-form-input sm="9" v-if="isEditing" v-model="editedUser.Dni"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mb-2">
                            <b-col class="text-left"><b>Teléfono:</b></b-col>
                            <b-col class="text-left">
                                <span v-if="!isEditing">{{ row.item.PhoneNumber }}</span>
                                <b-form-input sm="9" v-if="isEditing" v-model="editedUser.PhoneNumber"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mb-2">
                            <b-col class="text-left"><b>Título:</b></b-col>
                            <b-col class="text-left">
                                <span v-if="!isEditing">{{ row.item.Title }}</span>
                                <b-form-input sm="9" v-if="isEditing" v-model="editedUser.Title"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mb-2">
                            <b-col class="text-left"><b>Sector:</b></b-col>
                            <b-col class="text-left">
                                <span v-if="!isEditing">{{ row.item.Sector }}</span>
                                <b-form-input sm="9" v-if="isEditing" v-model="editedUser.Sector"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mb-2">
                            <b-col class="text-left"><b>País:</b></b-col>
                            <b-col class="text-left">
                                <span v-if="!isEditing">{{ row.item.Country }}</span>
                                <b-form-input sm="9" v-if="isEditing" v-model="editedUser.Country"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col class="text-left"><b>Fecha de Nacimiento:</b></b-col>
                            <b-col class="text-left">
                                <span v-if="!isEditing">{{ formatBirthday(row.item.Birthday) }}</span>

                                <VueDatePicker v-model="editedUser.Birthday" v-if="isEditing" class="rounded-0"
                                    id="doc_date" no-header min-date="1941" :max-date="new Date()" placeholder="Fecha"
                                    size="sm">
                                </VueDatePicker>
                            </b-col>
                        </b-row>
                        <template v-if="isEditing">
                            <b-card-title>Funcionalidades Adicionales</b-card-title>
                            <hr class="mt-2">
                        </template>
                        <b-row class="mb-2">
                            <b-col class="text-left"><b>Blockchain:</b></b-col>
                            <b-col class="text-left">
                                <div v-if="!isEditing">
                                    <span class="mr-2">{{ row.item.Blockchain }}</span>
                                    <b-icon :icon="row.item.Blockchain ? 'check-circle-fill' : 'x-circle-fill'"
                                        :variant="row.item.Blockchain ? 'success' : 'danger'" />
                                </div>
                                <b-form-checkbox v-if="isEditing" v-model="editedUser.Blockchain" switch>
                                    Blockchain Checkbox <b>(Checked: {{ editedUser.Blockchain }})</b>
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col class="text-left"><b>FeeNom:</b></b-col>
                            <b-col class="text-left">
                                <div v-if="!isEditing">
                                    <span class="mr-2">{{ row.item.FeeNom }}</span>
                                </div>
                                <b-form-radio-group v-if="isEditing" v-model="editedUser.FeeNom" :options="feeNominal"
                                    class="mb-3" value-field="item" text-field="name"
                                    disabled-field="notEnabled"></b-form-radio-group>
                            </b-col>
                        </b-row>
                        <template v-if="isEditing">
                            <b-card-title>Sistema</b-card-title>
                            <hr class="mt-2">
                        </template>
                        <b-row class="mb-2">
                            <b-col class="text-left"><b>Habilitacion de login:</b></b-col>
                            <b-col class="text-left">
                                <div v-if="!isEditing">
                                    <span class="mr-2">{{ row.item.IsActiveUser }}</span>
                                    <b-icon :icon="row.item.IsActiveUser ? 'check-circle-fill' : 'x-circle-fill'"
                                        :variant="row.item.IsActiveUser ? 'success' : 'danger'" />
                                </div>
                                <b-form-checkbox v-if="isEditing" v-model="editedUser.IsActiveUser" switch>
                                    IsActiveUser Checkbox <b>(Checked: {{ editedUser.IsActiveUser }})</b>
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-card-title>Acciones</b-card-title>
                        <hr>
                        <div>
                            <cid-button v-if="!isSaveChange" block size="sm" variant="primary" @click="toggleEditing">
                                {{ isEditing ? 'Volver' : 'Editar' }}
                            </cid-button>
                            <cid-button block v-if="isSaveChange" size="sm" variant="success"
                                @click="updatedDataUserModal">Guardar</cid-button>
                        </div>
                    </b-col>

                </b-row>
            </b-card>
            <template v-slot:overlay>
                <div class="text-center my-2">
                    <b-spinner class="align-middle mr-1 text-cid-primary"></b-spinner>
                    <strong>Actualizando...</strong>
                </div>
            </template>
            <b-modal id="updateConfirmation" class="p-0" centered no-close-on-backdrop hide-footer hide-header>
                <b-row class="mt-3 text-center">
                    <b-col>
                        <b-icon-exclamation-triangle class="warning-icon"></b-icon-exclamation-triangle>
                        <h4 class="mt-2">¿Estás seguro de actualizar este usuario?</h4>
                    </b-col>
                </b-row>

                <div class="row text-center mb-2">
                    <div class="col-sm mt-1 d-flex justify-content-around">
                        <cid-button class="px-5 " size="sm" @click="saveChanges">
                            Confirmar
                        </cid-button>
                        <cid-button class="px-5 " size="sm" @click="hideMoldals('updateConfirmation')">
                            Cancelar
                        </cid-button>
                    </div>
                </div>
            </b-modal>
        </b-overlay>


    </div>
</template>
<script scoped>
import axios from 'axios';
export default {
    name: 'row-data-action',
    props: {
        row: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isEditing: false,
            editedUser: {},
            updatedDataUser: false,
            isSaveChange: false,
            feeNominal: [
                { item: { value: 1 }, name: 'Free' },
                { item: { value: 2 }, name: 'Standard' },
                { item: { value: 3 }, name: 'Enterprise' }
            ],
            saveLocalRow: undefined,
        }
    },
    watch: {
        editedUser: {
            handler(newVal) {
                this.editUser(newVal);
            },
            deep: true
        }
    },
    mounted() {
        console.log(this.row.item);
        // esto es para que no se modifique el objeto original
        this.saveLocalRow = JSON.parse(JSON.stringify(this.row.item));
        console.log(this.saveLocalRow);
        // esto es para que se seleccione el valor del radio button
        this.saveLocalRow.FeeNom = this.feeNominal.find(fee => fee.name === this.row.item.FeeNom).item;
        // esto es para los cambios para el usuario

        this.editedUser = JSON.parse(JSON.stringify(this.saveLocalRow));

    },
    methods: {
        onContext(ctx) {
            // formato de fecha
            this.formatted = ctx.selectedFormatted
            // fecha seleccionada
            this.selected = ctx.selectedYMD
        },
        formatBirthday(birthday) {
            const utcDate = new Date(birthday);
            const localDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000);
            const formattedDate = localDate.toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            return formattedDate;
        },
        editUser(newValue) {
            const isEdited = JSON.stringify(newValue) !== JSON.stringify(this.saveLocalRow);
            this.isSaveChange = isEdited;
        },
        deleteDataUserModal() {
            this.showMoldals('deleteConfirmation')
        },
        updatedDataUserModal() {
            this.showMoldals('updateConfirmation')
        },
        async saveChanges() {
            this.hideMoldals('updateConfirmation');
            this.updatedDataUser = true;

            const foundItem = this.feeNominal.find(fee => fee.item.value === this.editedUser.FeeNom.value);
            const FeeName = foundItem ? foundItem.name : '';

            let formData = new FormData();
            formData.append('aId', this.editedUser.aId);
            formData.append('Name', this.editedUser.Name);
            formData.append('Dni', this.editedUser.Dni); /*Cédula o pasaporte*/
            formData.append('Surname', this.editedUser.Surname);
            formData.append('Email', this.editedUser.Email);
            formData.append('PhoneNumber', this.editedUser.PhoneNumber);
            formData.append('Title', this.editedUser.Title);
            formData.append('Sector', this.editedUser.Sector);
            formData.append('Country', this.editedUser.Country);
            formData.append('Birthday', this.editedUser.Birthday);
            formData.append('Username', this.editedUser.Username);
            formData.append('FeeNom', this.editedUser.FeeNom.value);
            formData.append('IsVerify', this.editedUser.IsVerify);
            formData.append('Blockchain', this.editedUser.Blockchain);
            formData.append('IsActiveUser', this.editedUser.IsActiveUser);

            axios.post('/api/Account/UpdatedUser', formData)
                .then(response => {
                    if (response.data.UpdatedUserError) {
                        response.data.UpdatedUserError.forEach(error => {
                            this.$bvToast.toast(error, {
                                title: 'Error en la solicitud de Actualizacion intentelo de nuevo 1',
                                variant: 'danger'
                            });
                        });

                        this.isEditing = true;
                        this.updatedDataUser = false;
                        this.isSaveChange = true;
                        return;
                    }
                    this.saveLocalRow = JSON.parse(JSON.stringify(this.editedUser));
                    this.saveLocalRow.FeeNom = FeeName;
                    return response.data;
                })
                .then(response => {
                    if (response.IsSuccessFul) {
                        this.$emit('update-row', this.saveLocalRow);
                        this.isEditing = false;
                        this.updatedDataUser = false;
                        this.isSaveChange = false;
                    }
                }).catch(error => {
                    const h = this.$createElement;
                    let errors = error.response.data.errors;
                    const vNodesErrors = [];
                    for (const key in errors) {
                        if (Object.prototype.hasOwnProperty.call(errors, key)) {
                            const errorMessage = errors[key];
                            vNodesErrors.push(h('li', { key }, errorMessage));
                        }
                    }

                    const vNodesMsg = h('div', { class: 'text-center mb-0' }, [
                        h('ul', { class: 'error-list' }, vNodesErrors)
                    ]);
                    this.$bvToast.toast(vNodesMsg, {
                        title: `Error de petición: ${error.response.status}`,
                        variant: 'danger'
                    });
                    this.editedUser = JSON.parse(JSON.stringify(this.saveLocalRow));
                    this.updatedDataUser = false;
                    this.isEditing = true;
                    this.isSaveChange = false;
                })
        },
        toggleEditing() {
            this.isEditing = !this.isEditing;
        },
        showMoldals(modal) {
            this.$bvModal.show(modal);
        },
        hideMoldals(modal) {
            this.$bvModal.hide(modal);
        }
    },
}
</script>